import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { AuthService } from '@core/service/auth.service';
import * as _ from "lodash";

@Directive({
  selector: '[appAppAccess]'
})
export class AppAccessDirective {

  @Input() appAccess: string ="";
  user : any = {};
  constructor(private el: ElementRef, private authService: AuthService) {
  }

  ngOnInit() {
    this.user = this.authService.getCurrentUser();
   
    this.el.nativeElement.style.display = 'none';
    // let hasAcces = _.find(this.user.activite_utilisateur, (o) => { return o.codification?.trim().toLowerCase() == this.appAccess?.trim()?.toLowerCase() }) ||  _.find(this.user.activite_utilisateur_autre, (o) => { return o.codification?.trim().toLowerCase() == this.appAccess?.trim()?.toLowerCase() });

    const normalizedAccess = this.appAccess?.trim().toLowerCase();

    let hasAcces = 
      (this.user.activite_utilisateur ?? []).some((o:any) => 
        o?.codification?.trim().toLowerCase() === normalizedAccess
      ) ||
      (this.user.activite_utilisateur_autre ?? []).some((o:any) =>
        o?.codification?.trim().toLowerCase() === normalizedAccess
      );

    console.log(" this.appAccess ",this.appAccess);
    console.log(" hasAcces ",hasAcces);
    

    if (hasAcces) {
      this.el.nativeElement.style.display = 'block';
    }else {
      this.el.nativeElement.style.display = 'none';
    }
  }


}
